export class InfractionDocument {
    id:string;
    name:string;
    contentType:string;
    documentType:string;
    entryDate:string;

    constructor(other ?:InfractionDocument) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.contentType = other.contentType;
            this.documentType = other.documentType;

            this.entryDate = other.entryDate;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/infractionDocument.ts
 **/